module.exports = __webpack_public_path__ + "static/media/supermarket.5e3534b9.png";